import { PropsWithChildren } from "react";

import { SwitchCase } from "@enkor/toss-slash";
import { UseQueryResult } from "@enkor/react-query";

import EventCardSkeleton from "../../placeholders/EventCardSkeleton/EventCardSkeleton";

import * as S from "./SectionLayout.style";

interface SectionLayoutProps {
  status: UseQueryResult["status"];
  title: string;
}

const SectionLayout = ({
  status,
  title,
  children,
}: PropsWithChildren<SectionLayoutProps>) => {
  return (
    <S.EventListWrapper>
      <S.SectionTitle name="h5">{title}</S.SectionTitle>
      <SwitchCase
        value={status}
        caseBy={{
          pending: (
            <>
              <EventCardSkeleton />
              <EventCardSkeleton />
              <EventCardSkeleton />
              <EventCardSkeleton />
              <EventCardSkeleton />
            </>
          ),
          success: <>{children}</>,
        }}
      />
    </S.EventListWrapper>
  );
};

export default SectionLayout;
